import enIcon from "../../../../images/reino-unido.svg"
import glIcon from "../../../../images/galicia.png"
import esIcon from "../../../../images/españa.png"
const svg = {
    en: enIcon,
    gl: glIcon,
    es: esIcon
}
export default svg;